import { ReactNode, createContext, useContext } from 'react';

export type FlowExecutionState = 'visited' | 'active';

export type FlowExecutionTrace = {
	nodeStates: Map<string, FlowExecutionState>;
	edgeStates: Map<string, FlowExecutionState>;
	nodeVisitCounts: Map<string, number>;
	edgeVisitCounts: Map<string, number>;
};

export function getExecutionTraceStrokeWidth(visitCount: number) {
	return Math.min(7, 2.5 + 0.9 * Math.log2(Math.max(1, visitCount)));
}

const FlowExecutionTraceContext = createContext<FlowExecutionTrace | undefined>(undefined);

export function FlowExecutionTraceProvider({ trace, children }: { trace?: FlowExecutionTrace; children: ReactNode }) {
	return <FlowExecutionTraceContext.Provider value={trace}>{children}</FlowExecutionTraceContext.Provider>;
}

export function useFlowExecutionTraceState() {
	return useContext(FlowExecutionTraceContext);
}

export function mergeFlowExecutionState(current: FlowExecutionState | undefined, next: FlowExecutionState): FlowExecutionState {
	return current === 'active' || next === 'active' ? 'active' : next;
}
